/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageAttachment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import PreviewAttachment from './PreviewAttachment/index'
import PreviewImage from 'DesignSystem/PreviewImage/index'
import React from 'react'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ImageAttachment({
  children,
  viewPath = "/DesignSystem/CommsThreadEventAttachments/Content/Attachment/ImageAttachment"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let attachmentUrlValueData = fromData.useDataValue({ viewPath,
context: 'attachment',
path: 'url',
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let attachmentNameValueData = fromData.useDataValue({ viewPath,
context: 'attachment',
path: 'name',
})
  return (<React.Fragment
>
<button
  data-testid="ImageAttachment.Vertical"
  data-view-path={viewPath}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'PreviewAttachment/Content'))}
 {...isHoveredBind}
 className={`views-block ${styles.Vertical}`}
>
<PreviewImage
  viewPath={`${viewPath}/PreviewImage`}
 data="attachment.url"
 url={attachmentUrlValueData}
 maxWidth={150}
 maxHeight={150}
/>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="grey"
 style="filled"
 marginTop={dtSpaceXxs}
 maxWidth={150}
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 data="attachment.name"
 text={attachmentNameValueData}
/>
)}
</TysiaTag>
</button>
<PreviewAttachment
  viewPath={`${viewPath}/PreviewAttachment`}
/>
{children}
</React.Fragment>)
}